import React, { useState } from 'react'
import Modal from '../../../../common/modal'
import { Box, Button, Checkbox, FormControlLabel } from '@mui/material'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { useTranslation } from '../../../../../i18n/I18nProvider'
const RechargeRequestCancelRemark = ({ updateModal, setShowModel, sendOTPRequest, handleAcceptData, loginData, handleReject,setTextAreaValue,getCargoSettingData }) => {
    const { translations } = useTranslation()
    const rdcn = translations?.rechargeDebitCreditNote || {}
    const cs = translations?.common || {}
    const handleRemark = (value) => {
        setTextAreaValue(value)
    }
    const handleSave = () => {
        if (getCargoSettingData[0].IsRechargeApprovalOTP===0) {
            // reject API call
            handleReject()
        } else {
            sendOTPRequest(handleAcceptData?.BranchID)   
        }
        setShowModel(false)
    }
    return (
        <Modal headTxt={rdcn.rechargeRequestCancelRemark || 'Recharge Request Cancel Remark'} width={'50%'} updateModal={updateModal}>
            <Box style={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'column', margin: '15px' }}>
                <Box sx={{ display: 'inline-flex', padding: '0% 0px', height: '100px', marginBottom: '10px' }}>
                    <textarea
                        className="ticket-textarea"
                        id="rulesInput"
                        name="rulesInput"
                        // value={selectedFormtatData.RulesAndRegulations || ''}
                        onChange={(e) => handleRemark(e.target.value)}
                        rows="10"
                        placeholder={rdcn.typeYourRemarksHere || 'Type Your Remarks here...'}
                        style={{
                            width: '100%',
                            boxSizing: 'border-box',
                            borderRadius: '6px',
                            borderColor: '#00000026',
                            padding: '15px',
                            fontFamily: 'Roboto',
                            fontSize: '14px',
                            fontWeight: '500',
                            color: '#444444',
                            // borderColor: borderColor,
                        }}
                    // onKeyDown={(e) => navigation1(e, 'declaration', 'website')}
                    // onFocus={handleFocus}
                    // onBlur={handleBlur}
                    />
                </Box>
                <Item sx={sx.itemsx} style={{ textAlign: 'right' }}>
                    <Button variant="contained" className="go click-button" onClick={handleSave}>
                        {cs.save || 'SAVE'}
                    </Button>
                </Item>
            </Box>
        </Modal>
    )
}

export default RechargeRequestCancelRemark